import React from "react";

/**
 * Instantly set reference to a state
 */
export function useStateRef<T>(currentValue: T) {
  const ref = React.useRef(currentValue);
  ref.current = currentValue;
  return ref;
}
